<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import ChargeWallet from '@/components/wallet/ChargeWallet'

export default {
  name: 'Charge',
  components: {
    Layout,
    PageHeader,
    ChargeWallet,
  },

  data() {
    return {
      title: 'کیف پول من',
      items: [
        {
          text: 'کیف پول من',
          to: { name: 'wallet' },
        },
        {
          text: 'شارژ کیف پول',
          active: true,
        },
      ],
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <template>
      <div class="row">
        <div class="col-12">
          <ChargeWallet />
        </div>
      </div>
    </template>
  </Layout>
</template>
